import { render, staticRenderFns } from "./RptPercepciones.vue?vue&type=template&id=3a2c054f&"
import script from "./RptPercepciones.vue?vue&type=script&lang=js&"
export * from "./RptPercepciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports